export const shadow = {
  boxShadow: "0px 1px 3px 1px rgba(135,135,135,0.3)",
};
